import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=1df2722b&scoped=true&"
import script from "./ArticleItem.vue?vue&type=script&lang=ts&"
export * from "./ArticleItem.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleItem.vue?vue&type=style&index=0&id=1df2722b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df2722b",
  null
  
)

component.options.__file = "ArticleItem.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VAvatar,
  VBtn,
  VCard,
  VCardText,
  VDivider,
  VExpansionPanelContent,
  VFlex,
  VIcon,
  VLayout,
  VSelect,
})
